<template>
  <div
    v-if="openNotification"
    class="notification-modal"
  >
    <div class="notification-modal__content">
      <h4>
        {{ title }}
      </h4>
      <span
        class="close"
        @click="closeModal"
      >
        &times;
      </span>
      <iframe
        :src="currentUrl"
        frameborder="0"
        style="width: 100%; height: 90%"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      openNotification: false,
      currentUrl: '',
    };
  },
  watch: {
    openNotification(newVal) {
      if (!newVal) {
        this.currentUrl = '';
      }
    },
  },
  methods: {
    openModal() {
      if (!this.url) {
        console.error('Nenhuma URL válida encontrada.');
        return;
      }

      const allowedProtocols = ['http:', 'https:'];
      let parsedUrl;
      try {
        parsedUrl = new URL(this.url);
      } catch (e) {
        console.error('URL inválida:', e);
        return;
      }
      if (!allowedProtocols.includes(parsedUrl.protocol)) {
        console.error('Protocolo não permitido.');
        return;
      }
      this.currentUrl = this.url;
      this.openNotification = true;
    },
    closeModal() {
      this.openNotification = false;
    },
  },
};
</script>

<style lang="scss">
.notification-modal {
  position: fixed;
  z-index: 99999;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;

  &__content {
    background-color: #fefefe;
    padding: 0 2px;
    border-radius: 6px;
    min-width: 900px;
    width: 80%;
    height: 90%;
    position: relative;
  }

  h4 {
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    color: #7f1a55;
    font-weight: 500;
    text-transform: uppercase;
  }

  .close {
    color: #7f1a54;
    float: right;
    font-size: 34px;
    font-weight: 700;
    position: absolute;
    right: 12px;
    top: 12px;

    &:hover,
    &:focus {
      color: #5d133d;
      text-decoration: none;
      cursor: pointer;
    }
  }
}
</style>
